// extracted by mini-css-extract-plugin
export var action = "RoyaltySetupCard-module__action___UvI4f";
export var card = "RoyaltySetupCard-module__card___Z-yN-";
export var completed = "RoyaltySetupCard-module__completed___jUWzd";
export var completedLinks = "RoyaltySetupCard-module__completedLinks___0wblx";
export var description = "RoyaltySetupCard-module__description___WyHar";
export var header = "RoyaltySetupCard-module__header___LfPlk";
export var inProgress = "RoyaltySetupCard-module__inProgress___ZNKh5";
export var notice = "RoyaltySetupCard-module__notice___p+aHF";
export var section = "RoyaltySetupCard-module__section___h8QGF";
export var status = "RoyaltySetupCard-module__status___UGgrj";
export var statusDot = "RoyaltySetupCard-module__statusDot___JG9mj";
export var title = "RoyaltySetupCard-module__title___4qbHU";
export var vendorId = "RoyaltySetupCard-module__vendorId___f41-6";
export var warning = "RoyaltySetupCard-module__warning___pLugf";